module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splash"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(" presenteert ")]), _vm._v(" "), _c('div', {
    staticClass: "link-image-container"
  }, [_c('div', {
    staticClass: "link-image"
  }, [_c('img', {
    staticClass: "sound-warning",
    attrs: {
      "src": require("../assets/sound.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "MZBlock",
    attrs: {
      "src": require("../assets/img-intro-moordzaak-block.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('span', {
    on: {
      "click": _vm.start,
      "touchend": _vm.start
    }
  }, [_c('img', {
    staticClass: "circle",
    attrs: {
      "src": require("../assets/img-intro-play-circle.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "arrow",
    attrs: {
      "src": require("../assets/img-intro-play-triangle.png")
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://om.nl"
    }
  }, [_c('img', {
    staticClass: "omlogo",
    attrs: {
      "src": require("../assets/img-intro-om-logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-822a6350!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Splash.vue
// module id = 122
// module chunks = 1